import axios from 'axios';
import {
  Connection2Document,
  Connection2Query,
  Connection2QueryVariables,
  ConnectionQuery,
} from './gqlQuery';

let cachedConnection: ConnectionQuery['connection'] | undefined;

/**
 * Retrieves new appsync url and appsync key
 * @throws {AxiosError} On connection problem
 */
export async function getConnection(): Promise<
  ConnectionQuery['connection'] | undefined
> {
  try {
    const { data } = await axios.post<{
      data: Connection2Query;
    }>(
      `https://gql-${process.env.VITE_APP_COLOR}.${process.env.VITE_APP_KIXIE_DOMAIN}/graphql`,
      {
        operationName: 'Connection2',
        query: Connection2Document,
        variables: {} as Connection2QueryVariables,
      },
      {
        headers: {
          authorization: 'FORCE_LAMBDA_AUTH',
        },
      }
    );
    return (cachedConnection = data.data.connection2);
  } catch (exception) {
    if (cachedConnection) {
      return cachedConnection;
    }
    throw exception;
  }
}
